<template>
  <div>
    <el-dialog
      title="赠送礼品卡"
      :visible.sync="dialogVisible"
      width="40%"
      :close-on-click-modal="false"
      :before-close="handleClose"
    >
      <el-form
        :model="formInfo"
        :rules="formRules"
        ref="formInfo"
        label-width="100px"
        v-loading="loading"
      >
        <el-form-item label="会员" prop="subscriberId">
          <el-select
            v-model="formInfo.subscriberId"
            filterable
            remote
            reserve-keyword
            placeholder="支持手机号与昵称模糊搜索"
            :remote-method="loadMemberUsers"
            :loading="loading"
            style="width:100%"
          >
            <el-option
              v-for="item in memberUsers"
              :key="item.id"
              :label="item.nickname + '（' + item.phoneNo + '）'"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="祝福语" prop="blessingWord">
          <el-input
            type="textarea"
            v-model="formInfo.blessingWord"
            placeholder="请输入祝福语"
            :autosize="{ minRows: 2, maxRows: 4 }"
            style="width:100%"
            maxlength="255"
          ></el-input>
        </el-form-item>
        <el-form-item label="购买价格" prop="price">
          <el-input-number
            v-model="formInfo.price"
            controls-position="right"
            clearable
            style="width:100%"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="面值">
          <el-input-number
            v-model="giftCardRecordInfo.amount"
            controls-position="right"
            clearable
            style="width:100%"
            disabled
          ></el-input-number>
        </el-form-item>
        <el-form-item label="购买时间" prop="buyTime">
          <el-date-picker
            v-model="formInfo.buyTime"
            type="date"
            placeholder="选择日期"
            style="width:100%"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            type="textarea"
            v-model="formInfo.remark"
            placeholder="请输入备注"
            :autosize="{ minRows: 2, maxRows: 4 }"
            style="width:100%"
            maxlength="255"
          ></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleGive">赠送</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { loadSubscriberListApi } from "@/api/subscriber";
import { giftCardGive } from "@/api/giftCard";
export default {
  name: "GiftCardGive",
  components: {},
  props: {},
  data() {
    return {
      dialogVisible: false,
      loading: false,
      giftCardRecordInfo: {},
      formInfo: {},
      formRules: {
        subscriberId: [
          { required: true, message: "请选择会员", trigger: "change" }
        ]
      },

      memberUsers: []
    };
  },
  created() {},
  mounted() {},
  methods: {
    loadMemberUsers(query) {
      let params = {};
      if (query !== "") {
        params.keyword = query;
      }
      this.loading = true;
      loadSubscriberListApi(params)
        .then(res => {
          if (res.data.status == 100) {
            this.memberUsers = res.data.results;
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleClose() {
      this.$emit("close");
      this.dialogVisible = false;
      this.formInfo = {};
    },
    open(info) {
      this.giftCardRecordInfo = info;
      this.dialogVisible = true;
      this.loading = false;
      this.formInfo = {
        subscriberId: undefined,
        id: info.id,
        price: info.price,
        buyTime: new Date(),
        blessingWord: info.blessingWord,
        remark: info.remark
      };
      this.loadMemberUsers();
    },
    handleGive() {
      this.$refs["formInfo"].validate(valid => {
        if (valid) {
          this.saveData();
        }
      });
    },
    saveData() {
      this.loading = true;
      giftCardGive(this.formInfo)
        .then(res => {
          if (res.data.status == 100) {
            this.$message({
              message: "赠送成功",
              type: "success"
            });
            this.handleClose();
            this.$emit("refresh");
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// giveGiftCard.vue?18a797ce